import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';
import { AppModule } from 'app/app.module';
import { EnvServer } from 'environments/enums/env-server.enum';
import { environment } from 'environments/environment';
import { hmrBootstrap } from 'hmr';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import 'zone.js';

if (environment.production) {
    enableProdMode();
}

// Register Swiper custom elements. We do this
// before bootstrapping the Angular application
// so that they're available before any part of
// our application tries rendering them.
registerSwiperElements();

if (environment.server !== EnvServer.Local) {
    Sentry.init({
        dsn: 'https://ee727c1d30c489a5aa411a0f4c7c7857@o4510793630220288.ingest.de.sentry.io/4510799968796752',
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        environment: environment.server === EnvServer.Prod ? 'prod' : environment.server === EnvServer.Dev ? 'dev' : 'stage',
        release: environment.version,
    });
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.hmr) {
    if (module['hot']) {
        hmrBootstrap(module, bootstrap);
    } else {
        console.error('HMR is not enabled for webpack-dev-server!');
        console.log('Are you using the --hmr flag for ng serve?');
    }
} else {
    bootstrap().catch((err) => console.log(err));
}
